import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=60308c28"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeViewCategoryItems: require('/var/www/html/js/productlisting/components/templates/home/view/CategoryItems.vue').default})
